import React from 'react';
import {
    AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
} from 'recharts';

const tooltipStyle = {
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: 6,
    color: '#e2e8f0',
    fontSize: 12,
};

/**
 * SessionTimelineCard — area chart of sessions per day for the last 30 days.
 * Expects `data` as an array of { date: "2026-03-01", count: 5 }.
 */
export default function SessionTimelineCard({ data }) {
    const chartData = (data || []).map(d => ({
        date: d.date.slice(5), // "03-01"
        sessions: d.count,
    }));

    const hasData = chartData.some(d => d.sessions > 0);

    return (
        <div style={styles.card}>
            <h3 style={styles.title}>Session Timeline</h3>
            <p style={styles.subtitle}>Sessions per day — last 30 days</p>
            {chartData.length > 0 ? (
                <ResponsiveContainer width="100%" height={180}>
                    <AreaChart data={chartData} margin={{ top: 8, right: 12, left: -20, bottom: 0 }}>
                        <defs>
                            <linearGradient id="sessionGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#22c55e" stopOpacity={0.4} />
                                <stop offset="95%" stopColor="#22c55e" stopOpacity={0.02} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="#334155" vertical={false} />
                        <XAxis
                            dataKey="date"
                            tick={{ fill: '#64748B', fontSize: 10 }}
                            axisLine={{ stroke: '#334155' }}
                            tickLine={false}
                            interval={Math.max(0, Math.floor(chartData.length / 8) - 1)}
                        />
                        <YAxis
                            tick={{ fill: '#64748B', fontSize: 11 }}
                            axisLine={false}
                            tickLine={false}
                            allowDecimals={false}
                        />
                        <Tooltip contentStyle={tooltipStyle} />
                        <Area
                            type="monotone"
                            dataKey="sessions"
                            stroke="#22c55e"
                            strokeWidth={2}
                            fill="url(#sessionGradient)"
                            dot={hasData ? { r: 2, fill: '#22c55e' } : false}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            ) : (
                <p style={styles.empty}>No session data for the last 30 days</p>
            )}
        </div>
    );
}

const styles = {
    card: {
        background: '#1e3a5f',
        border: '1px solid #2d4a6f',
        borderRadius: 8,
        padding: 20,
    },
    title: {
        margin: 0,
        fontSize: 14,
        fontWeight: 600,
        color: '#FFFFFF',
    },
    subtitle: {
        margin: '4px 0 12px',
        fontSize: 12,
        color: '#94A3B8',
    },
    empty: {
        color: '#64748B',
        fontSize: 13,
        textAlign: 'center',
        padding: '30px 0',
    },
};
